module.exports = __webpack_public_path__ + "img/u297.ce4bf25d.png";